/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
// components
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// styles
import {
  StyledContractContainer,
} from './styles';
import { StyledButton, StyledWrapperDropdown } from '../../../assets/styles/styles';

// assets

const CardContracts = (props) => {
  const { contracts, isMobileDevice, onDownloadContract, disabled } = props;

  return (
    <SimpleCard
      contentHeader={
        <section className="d-flex justify-content-between w-100">
          <article className="d-flex flex-column flex-grow-1">
            <p className="simplecard__title">Conoce tus documentos</p>
            <p className="simplecard__subtitle">Descarga tus documentos para revisarlos en detalle</p>
          </article>

        </section>
      }
      disabled={disabled}
    >
      <>
        {contracts.map((el, idx) => (
          <StyledWrapperDropdown key={shortid.generate()}>
            <StyledContractContainer
              className={`m-0 rounded-0 border-bottom-0 shadow-none ${(parseInt(idx, 10) + 1) % 2 !== 0 ? 'bg-color-f6' : ''
                }`}
              title={el.title}
              opened={el.isOpened}
            >
              <article>
                <h6 className="font-size-18 line-height-24 text-color-38 font-weight-500">
                  {el.title}
                </h6>
                {el.descriptions.typeListItems === 'ul' && (
                  <ul>
                    {el.descriptions.items.map((ele, index) => (
                      <li key={index}>{ele}</li>
                    ))}
                  </ul>
                )}
                {el.descriptions.typeListItems === 'ol' && (
                  <ol className="orderlist-10gap pl-4">
                    {el.descriptions.items.map((eli, index) => (
                      <li key={index}>{eli}</li>
                    ))}
                  </ol>
                )}
                {el.descriptions.typeListItems === '' && (
                  <>
                    {el.descriptions.items.map((elo, index) => (
                      <p key={index}>{elo}</p>
                    ))}
                  </>
                )}
              </article>
              {el.isDownloadable && (
                <div className="m-0 ml-md-3">
                  <StyledButton
                    disabled={false}
                    onClick={() => onDownloadContract(el.name, el.type, el.segment)}
                    prefix={isMobileDevice ? '' : 'line-download-2'}
                    variant="text"
                    sizeIcon="18"
                    className={`align-items-center ${isMobileDevice ? 'justify-content-start pl-0' : 'justify-content-center'
                      }`}
                  >
                    Descargar
                  </StyledButton>
                </div>
              )}
            </StyledContractContainer>
          </StyledWrapperDropdown>
        ))}
      </>
    </SimpleCard>
  );
};
/* istanbul ignore next */
CardContracts.defaultProps = {
  contracts: [],
  isMobileDevice: false,
  onDownloadContract: () => null,
};

CardContracts.propTypes = {
  contracts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.bool,
      isDownloadable: PropTypes.bool,
      descriptions: PropTypes.shape(),
    })
  ),
  isMobileDevice: PropTypes.bool,
  onDownloadContract: PropTypes.func,
};

export default CardContracts;
